export const BASE_URL = `${window.location.protocol}//${window.location.host}/api/v1`;
export const REFERENCE_STATUS_CHECK_INTERVAL = process.env.REACT_APP_REFERENCE_STATUS_CHECK_INTERVAL || 5000;
export const ANALYSIS_INTERVAL = process.env.REACT_APP_ANALYSIS_INTERVAL || 5000;

interface TranslateType {
    [key: string]: string
}
export const StatusTranslate: TranslateType = {
    'None': 'none',
    'On': 'on',
    'Off': 'off',
    'Flash': 'flash',
    'Short Flash': 'shortFlash',
    'Long Flash': 'longFlash',
    'Not On': 'notOn',
    'Not Off': 'notOff',
    'Not Available': 'notAvailable',
    'Disabled': 'disabled',
    'null': 'none',
    'Not configured': 'notConfigured'
};

export const ColorsTranslate: TranslateType = {
    'None': 'none',
    'red': 'red',
    'orange': 'orange',
    'green': 'green',
    'blue': 'blue',
    'user_specified': 'userSpecified',
    'Not Available': 'notAvailable'
};

export const TargetPixelValues = [
    { showValue: '1x1', value: 1 },
    { showValue: '3x3', value: 2 },
    { showValue: '5x5', value: 3 }
];

export const DesiredStatuValues = [
    { showValue: 'None', value: 'None' },
    { showValue: 'On', value: 'On' },
    { showValue: 'Long Flash', value: 'Long Flash' },
    { showValue: 'Short Flash', value: 'Short Flash' },
    { showValue: 'Off', value: 'Off' },
    { showValue: 'Not On', value: 'Not On' },
    { showValue: 'Not Off', value: 'Not Off' },
    { showValue: 'Flash', value: 'Flash' }
];

export const ColorValues = [
    { showValue: 'None', value: 'None' },
    { showValue: 'red', value: 'red' },
    { showValue: 'orange', value: 'orange' },
    { showValue: 'green', value: 'green' },
    { showValue: 'blue', value: 'blue' }
];

// regExs
export const regExNumber = /^[0-9]*$/;
export const regExIP =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export interface ROI {
    note2: string,
    desired_color: string[],
    desired_hue_x: number | null,
    desired_hue_y: number | null,
    name: string,
    analyzed_color: string,
    analyzed_hue: number|null,
    id: number,
    pos_x: number,
    pos_y: number,
    note: string,
    reference_brightness_max: number,
    enabled: boolean,
    desired_status: string,
    analyzed_status: string,
    reference_last_update: string,
    setting_last_update: string,
    analyzed_last_update: string,
    radius: number,
    reference_color: string,
    reference_hue: number|null,
    is_send_mail: boolean,
    reference_brightness_min: number,
    pixels: number,
    email_enabled: boolean,
    cloud_show: boolean,
    target_emails_count: number,
    consecutive_ok_count: number,
    consecutive_ng_count: number
}

export interface Camera {
    name: string
    rois: ROI[]
    connected: boolean
}

interface Pixels {
    [key: number]: string
}

export const TargetPixels: Pixels = {
    1: '1x1',
    2: '3x3',
    3: '5x5'
};

export const RecordingTime = [3, 5, 10, 15, 30, 60, 120];
